const dispatch = require("../../store.js").dispatch;
const Server = require("../../Server.js");

const PCardActions = require("../../actions/metadata/PCardActions.js");

const PCardActionCreators = {
    SelectTarget(test) {
        dispatch({
            type: PCardActions.TargetSelected,
            mode: test
        });
    }
};

module.exports = PCardActionCreators;


// WEBPACK FOOTER //
// ./src/actionCreators/metadata/PCardActionCreators.js